const body = document.querySelector("body");
const  focusableElements =
'button:not([class*="js-search-btn"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const modal = document.getElementById('js-main-menu-container'); // select the modal by it's id
const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
const focusableContent = modal.querySelectorAll(focusableElements);
const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
 
export default function(openMenuBtnId, closeMenuBtnId, overlayId) {
  document.getElementById(openMenuBtnId)
    .addEventListener('click', openMenu);

  document.getElementById(overlayId)
    .addEventListener('click', closeMenu);

  document.getElementById(closeMenuBtnId)
    .addEventListener('click', closeMenu);

    
}

function openMenu() {
  body.classList.add("nav-open");

  tabTrap("js-main-menu-container");
}

function closeMenu(event) {
  body.classList.remove("nav-open");
}

function tabTrap(modalId) {
  

  // const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  // const focusableContent = modal.querySelectorAll(focusableElements);
  // const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

  // document.addEventListener('keydown', function(e, firstFocusableElement, lastFocusableElement) { keyPressed(e, firstFocusableElement, lastFocusableElement); });
  document.addEventListener('keydown', keyPressed.bind(event));

  firstFocusableElement.focus();

  function keyPressed() {
    let isTabPressed = event.key === 'Tab';

    if (!isTabPressed) {
      return;
    }

    if (event.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        event.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        event.preventDefault();
      }
    }
  }
}
